<template>
   <div style="padding: 0px;">
        <img src="../assets/img/404-error-not-found-edit.png" class="imagen">
    </div>

</template>

<script>


export default {
  mounted() {
  
  },
  methods: {
  },
};
</script>
<style scoped>
.imagen {

  display: block;
  width: 50%;
  margin-left: auto;
  margin-right: auto;
  
}
</style>

